import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";
import InputAdornment from "@mui/material/InputAdornment";

const MIN_HEIGHT = 19 + 4;
const MAX_HEIGHT = 114;

export default function InputField(props) {
  const [isFocused, setIsFocused] = useState(false);
  const expandedTextareaRef = useRef(null);
  const containerRef = useRef(null);
  const { showNAButton = true, form, field, ...restProps } = props;

  useEffect(() => {
    const textarea = expandedTextareaRef.current;
    if (!textarea) return;

    const adjustHeight = () => {
      textarea.style.height = `${MIN_HEIGHT}px`;
      if (isFocused) {
        textarea.style.height = "auto";
        const scrollHeight = textarea.scrollHeight;
        textarea.style.height = `${Math.min(scrollHeight, MAX_HEIGHT)}px`;
      }
    };

    adjustHeight();
  }, [props.value, isFocused]);

  const handleFocus = (e) => {
    setIsFocused(true);
    if (restProps.onFocus) restProps.onFocus(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (restProps.onBlur) restProps.onBlur(e);
  };

  const isEmpty = !props.value || props.value === "";
  const showNABtn = showNAButton && isFocused && isEmpty;

  const handleNAClick = () => {
    if (form && field) {
      form.setFieldValue(field.name, "N/A");
    }
  };

  return (
    <Box position="relative" minHeight={40}>
      <FormControl
        fullWidth
        sx={
          isFocused
            ? {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                backgroundColor: "white",
                zIndex: 1300,
              }
            : undefined
        }
        ref={containerRef}
      >
        <TextField
          {...restProps}
          multiline={true}
          rows={1}
          inputRef={expandedTextareaRef}
          onFocus={handleFocus}
          onBlur={handleBlur}
          InputProps={{
            ...restProps.InputProps,
            endAdornment: showNABtn ? (
              <InputAdornment position="end">
                <Chip
                  label="N/A"
                  size="small"
                  clickable
                  color="primary"
                  variant="outlined"
                  onMouseDown={handleNAClick}
                  sx={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ) : restProps.InputProps?.endAdornment,
          }}
        />
      </FormControl>
    </Box>
  );
}
